import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class RestoredSessionLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const background = new Phaser.GameObjects.Graphics(scene);
        background.fillStyle(0x2c241f);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(background);    

        const titleContainer = new Phaser.GameObjects.Container(scene); 
        titleContainer.x = GameConstants.GAME_WIDTH / 2;
        titleContainer.y = GameConstants.GAME_HEIGHT / 2;
        titleContainer.scaleX = .9 * GameVars.scaleX;
        titleContainer.scaleY = .9;
        titleContainer.alpha = 0;
        this.add(titleContainer);

        const levelTitleBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "level_title_background");
        titleContainer.add(levelTitleBackground);

        const menuTitleBackground = new Phaser.GameObjects.Image(this.scene, -255, -55, "texture_atlas_1", "tab_boards_daily_games");
        menuTitleBackground.setOrigin(0);
        titleContainer.add(menuTitleBackground);

        const welcomeLabel = new Phaser.GameObjects.Text(this.scene, menuTitleBackground.x + 30, menuTitleBackground.y + 20, "VÄLKOMMEN TILLBAKA", {fontFamily: "OpenSans-CondLight", fontSize: "52px", color: "#7C5D46"});
        welcomeLabel.setOrigin(0);
        titleContainer.add(welcomeLabel);

        const translatedWelcomeLabe = new Phaser.GameObjects.Text(this.scene, 0, 32, gameText.WELCOME[lan], {fontFamily: "Arial", fontSize: "24px", color: "#7C5D46", fontStyle: "bold"});
        translatedWelcomeLabe.scaleX = .8;
        translatedWelcomeLabe.setOrigin(.5);
        titleContainer.add(translatedWelcomeLabe);

        this.scene.tweens.add({
            targets: titleContainer,
            alpha: 1,
            scaleX: GameVars.scaleX,
            scaleY: 1,
            duration: 800,
            delay: 1000,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    
        this.scene.tweens.add({
            targets: background,
            alpha: .6,
            duration: 1000,
            ease: Phaser.Math.Easing.Cubic.In
        });

        this.scene.tweens.add({
            targets: background,
            alpha: 0,
            duration: 1000,
            delay: 2500,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        this.scene.tweens.add({
            targets: titleContainer,
            alpha: 0,
            scaleX: 1.05 * GameVars.scaleX,
            scaleY: 1.05,
            duration: 1000,
            delay: 2500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                this.destroy();
            },
            onCompleteScope: this
        });
    }
}
